export default __webpack_public_path__ + "static/media/Step2-Lovrican.24d060c6.png";